import {
  getScopeHasUnread,
  getScopeUnreadCount,
} from "../../../actions/annotations";

const ANNOTATION_UNREAD_ROW_BG = "#fef2f2";
const ANNOTATION_UNREAD_ROW_HOVER_BG = "#fee2e2";
const BRAND_ROW_BG = "inherit";
const BRAND_ROW_HOVER_BG = "#f9fafb";
const AGENCY_ROW_BG = "#f5f5f5";
const AGENCY_ROW_HOVER_BG = "#eeeeee";

export const getAnnotationUnreadPresentation = ({
  readStateByScope,
  advertiserID,
  isAgency,
  variant = "brand",
}) => {
  const hasUnread = getScopeHasUnread({
    readStateByScope,
    advertiserID,
    isAgency,
  });
  const unreadCount = getScopeUnreadCount({
    readStateByScope,
    advertiserID,
    isAgency,
  });

  const baseBackground = variant === "agency" ? AGENCY_ROW_BG : BRAND_ROW_BG;
  const baseHoverBackground =
    variant === "agency" ? AGENCY_ROW_HOVER_BG : BRAND_ROW_HOVER_BG;

  return {
    hasUnread,
    unreadCount,
    rowSx: {
      backgroundColor: hasUnread ? ANNOTATION_UNREAD_ROW_BG : baseBackground,
      "&:hover": {
        backgroundColor: hasUnread
          ? ANNOTATION_UNREAD_ROW_HOVER_BG
          : baseHoverBackground,
      },
    },
    nameTypographyWeight: hasUnread ? 600 : 500,
  };
};
